var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: { width: "860px", visible: _vm.dialogVisible, center: "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "titleDialog",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_c("p", [_vm._v("个人信息确认")]), _c("i")]
          ),
          _c("div", { staticClass: "myDataDiv" }, [
            _c("div", { staticClass: "myDataDivData" }, [
              _c(
                "div",
                { staticClass: "myDataImgDiv" },
                [
                  _vm.personInfo.thumb
                    ? _c("el-image", {
                        staticClass: "myDataImg",
                        attrs: { src: _vm.personInfo.thumb },
                      })
                    : _c("img", {
                        staticClass: "myDataImg",
                        attrs: { src: require("@/assets/images/default.jpg") },
                      }),
                  _c("p", [_vm._v("照片信息")]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "myDataText" },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", [
                          _vm._v("姓名：" + _vm._s(_vm.personInfo.title)),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", {}, [
                          _vm._v("联系电话：" + _vm._s(_vm.personInfo.mobile)),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", {}, [
                          _vm._v(" 报考专业： "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.personInfo.profession_title)),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", [
                          _vm._v(
                            "准考证号：" + _vm._s(_vm.personInfo.exam_number)
                          ),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", {}, [
                          _vm._v(
                            "身份证号：" + _vm._s(_vm.personInfo.identity)
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "myDataButton" }, [
              _c("p", [_vm._v("若信息有误，请联系管理员")]),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { plain: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.setNext()
                        },
                      },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }